import React, { useEffect } from "react";
import Banner from "../components/accounts/Banner";
import AccessLadder from "../components/accounts/AccessLadder";
import MarketMode from "../components/accounts/MarketMode";
import DifferentDoors from "../components/accounts/DifferentDoors";
import WhatOpens from "../components/accounts/WhatOpens";
import ThreeMoves from "../components/accounts/ThreeMoves";
import FourLevels from "../components/accounts/FourLevels";
import Faq from "../components/accounts/Faq";

function Accounts() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden">
      <Banner />
      <AccessLadder />
      <MarketMode />
      <DifferentDoors />
      <WhatOpens />
      <ThreeMoves />
      <FourLevels />
      <Faq />
    </div>
  );
}

export default Accounts;
